import useSWR from 'swr';

import { Order } from '../types';
import { axiosInstance, endpoints, fetcher } from '../utils/axios';

export function useGetOrderById(id: number) {
  const url = endpoints.orders.getById(`${id}`);
  return useSWR(url, fetcher, {
    keepPreviousData: false,
    revalidateOnFocus: true,
  });
}

export async function processFreeOrder(cartId: number, promoter?: string): Promise<Order> {
  let url = endpoints.orders.processFreeOrder(`${cartId}`);

  if (promoter) {
    url = `${url}?promoter=${promoter}`;
  }

  const response = await axiosInstance.post<Order>(url);
  return response.data;
}
